import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import '@atlassian/aui/lib/css/aui-reset.css';
import '@atlassian/aui/dist/aui/css/aui.css';
import '@atlassian/aui/dist/aui/css/aui-experimental.css';

import {setEventsData} from './redux/actions/';
import {routes, dataRefreshInterval} from './constants/';
import {translate} from './translate';
import * as johnsonEvents from './johnson-events';
import {getData} from './api';
import Body from './components/Body/Body';

export class App extends PureComponent {
    static childContextTypes = {
        i18n: PropTypes.func,
    };

    static propTypes = {
        setEventsData: PropTypes.func.isRequired,
    };

    getChildContext() {
        return {
            i18n: this.i18n,
        };
    }

    i18nMap = window ? window.i18n : null;
    i18n = (...args) => translate(this.i18nMap, ...args);

    componentDidMount() {
        this.initData(window.initialData);
    }

    updateEventsData(payload) {
        const sortedEvents = johnsonEvents.sortByEvent(payload.events);
        const eventsByType = johnsonEvents.sortByType(sortedEvents.events);
        const eventStats = johnsonEvents.stats(eventsByType);
        const oldEventsDataRows = johnsonEvents.oldEventsToTableRowArrays(sortedEvents.oldEvents, this.i18n);

        this.props.setEventsData({
            oldEvents: oldEventsDataRows,
            newEvents: eventsByType,
            stats: eventStats,
            checksComplete: payload.checksComplete,
            canDismissEvents: payload.canDismissEvents,
            errorsPresentButHidden: payload.errorsPresentButHidden,
        });
    }

    initData(initialData) {
        if (typeof initialData !== 'undefined') {
            this.setData(initialData);
        } else {
            this.fetchData();
        }
    }

    setData = (jsonPayload = {}) => {
        this.updateEventsData(jsonPayload);
        setTimeout(this.fetchData, dataRefreshInterval);
    };

    fetchData = () => {
        getData(routes.data)
            .then(this.setData)
            .catch(() => setTimeout(this.fetchData, dataRefreshInterval));
    };

    render() {
        return (
            <Body />
        );
    }
}

const mapDispatchToProps = {
    setEventsData,
};

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js